import { DocsRouter } from "@/components/shared/docs/router";
import { ListViewColumnI } from "@/lib/types/list";

export const INFINITE_LOADER_SCROLL_WITH_OBSERVER_INDICATOR_ID =
  "lists-infinite-loader-scroll-indicator";

export const TABLE_HEADER_ROW_CLASSNAME =
  "flex min-h-[48px] items-center border-b border-b-[#E4E4E7] group/row bg-white";

export const TABLE_ROW_CLASSNAME =
  "flex min-h-[48px] items-center border-b border-b-[#E4E4E7] group/row";

export const TABLE_CELL_CLASSNAME =
  "border-r border-r-[#E4E4E7] bg-white transition-colors self-stretch will-change-[width]";

export const TABLE_COLUMN_ANIMATION_CLASSNAME = "bg-[#F4F5FF]";

export const TABLE_CELL_ANIMATION_START_CLASSNAME = "bg-white";

export const TABLE_CELL_ANIMATION_END_CLASSNAME = "bg-[#F4F5FF]";

export const TABLE_CELL_ELLIPSIS_CLASSNAME =
  "block w-full min-w-0 max-w-full overflow-hidden truncate text-ellipsis whitespace-nowrap text-nowrap";

export const TABLE_CELL_PILL_CLASSNAME = "px-2 py-1 typography-body-4";

export const ACTIONS_COLUMN_ID = "actions";
/**
 * Reserved column names
 */
export const RESERVED_COLUMN_NAME_PROSPECT_NAME = "Prospect Name";
export const RESERVED_COLUMN_NAME_DIALS = "Dials";
export const RESERVED_COLUMN_NAME_TITLE = "Title";
export const RESERVED_COLUMN_NAME_COOLDOWN = "Cooldown time";
export const RESERVED_COLUMN_NAME_ACCOUNT_NAME = "Account Name";
export const RESERVED_COLUMN_NAME_TIMEZONE = "Timezone";
export const RESERVED_COLUMN_NAME_LAST_DISPOSITION = "Last Disposition";
export const RESERVED_COLUMN_NAME_ACCOUNT_STATUS = "Account Status";
export const RESERVED_COLUMN_NAME_MEETING_OUTCOME = "Meeting Outcome";
export const RESERVED_COLUMN_NAME_ACCOUNT_DQ_REASON = "Account DQ Reason";
export const RESERVED_COLUMN_NAME_CONTACT_TYPE = "Contact Type";
export const RESERVED_COLUMN_NAME_NEXT_TOUCH_TIME = "Next Touch Time";
export const RESERVED_COLUMN_NAME_ACCOUNT_SUMMARY = "Account Summary";

export const MIN_WIDTH_FIRST_COLUMN_ACTVIVE_DIALER = 280;

export const PRIMARY_NAVIGATION_HEIGHT = 64;

export const TABLE_SECTION_HEADER_HEIGHT = 166;
export const TABLE_SECTION_ROW_HEIGHT = 48;

export const TABLE_SECTION_TOTAL_HEADER_HEIGHT =
  PRIMARY_NAVIGATION_HEIGHT +
  TABLE_SECTION_HEADER_HEIGHT +
  TABLE_SECTION_ROW_HEIGHT;

export const TABLE_SECTION_FOOTER_HEIGHT = 48 * 2;

export const TABLE_SECTION_ACTIONS_COLUMN_WIDTH_EXPANDED = 160;
export const TABLE_SECTION_ACTIONS_COLUMN_WIDTH_COLLAPSED = 48;

/**
 * Placeholder columns for the table section
 * to populate the table loading state
 * when the columns data is not available
 */
export const PLACEHOLDER_COLUMNS: ListViewColumnI[] = Array.from(
  { length: 8 },
  (_, index) => ({
    column_id: `placeholder-${index}`,
    column_type_id: index.toString(),
    data_type: "string",
    name: "",
    is_hidden: false,
    is_frozen: false,
    column_order: index,
    is_editable: false,
  })
);

export const TABLE_COLUMN_DOCS_PATHS = {
  [RESERVED_COLUMN_NAME_PROSPECT_NAME]: DocsRouter.listsProspectName(),
  [RESERVED_COLUMN_NAME_DIALS]: DocsRouter.listsDials(),
  [RESERVED_COLUMN_NAME_TITLE]: DocsRouter.listsTitle(),
  [RESERVED_COLUMN_NAME_COOLDOWN]: DocsRouter.listsCooldown(),
  [RESERVED_COLUMN_NAME_ACCOUNT_NAME]: DocsRouter.listsAccountName(),
  [RESERVED_COLUMN_NAME_TIMEZONE]: DocsRouter.listsTimezone(),
  [RESERVED_COLUMN_NAME_LAST_DISPOSITION]: DocsRouter.listsLastDisposition(),
  [RESERVED_COLUMN_NAME_ACCOUNT_STATUS]: DocsRouter.listsAccountStatus(),
  [RESERVED_COLUMN_NAME_MEETING_OUTCOME]: DocsRouter.listsMeetingOutcome(),
  [RESERVED_COLUMN_NAME_ACCOUNT_DQ_REASON]: DocsRouter.listsAccountDQReason(),
  [RESERVED_COLUMN_NAME_CONTACT_TYPE]: DocsRouter.listsContactType(),
  [RESERVED_COLUMN_NAME_NEXT_TOUCH_TIME]: DocsRouter.listsNextTouchTime(),
  [RESERVED_COLUMN_NAME_ACCOUNT_SUMMARY]: DocsRouter.listsAccountSummary(),
};
